import React from 'react';

interface ActivityLateCompletionMessageProps<T = never> {
	completeByDate: string
	completeByLabel?: string
}

const ActivityLateCompletionMessageDefaultProps = {
	completeByDate:  null,
	completeByLabel: null,
} satisfies Partial<ActivityLateCompletionMessageProps>

function ActivityLateCompletionMessage<T>( props: ActivityLateCompletionMessageProps<T> ){
	
	const { completeByDate, completeByLabel } = { ...ActivityLateCompletionMessageDefaultProps, ...props };
	
	return (
		<>This activity has gone beyond its designated complete by date of <strong>{ completeByDate }</strong>{ completeByLabel ? ` (${ completeByLabel })` : '' }. Please adjust your map accordingly.</>
	);
}

function generateActivityLateCompletionMessageHTML( completeByDate: string, completeByLabel: string = null, ){
	
	return `This activity has gone beyond its designated complete by date of <strong>${ completeByDate }</strong>${ completeByLabel ? ` (${ completeByLabel })` : '' }. Please adjust your map accordingly.`;
}

export {
	ActivityLateCompletionMessage,
	ActivityLateCompletionMessageDefaultProps,
	type ActivityLateCompletionMessageProps,
	generateActivityLateCompletionMessageHTML,
};
